import { FormControl } from '@angular/forms';
import { BvsBaseFiguresFormModel } from '@shared/models/forms/bvs-base-figures-form.model';
import { CallidusBvsVersicherungssummeKunde } from '@backend/models';

export function createBvsFiguresBaseForm(): BvsBaseFiguresFormModel {
  return {
    isRechtsschutzSelected: new FormControl<boolean | null>(null),
    isKeinSelbstbehaltBeiRechtsschutzSelected: new FormControl<boolean | null>(null),
    isCharterSelected: new FormControl<boolean | null>(null),
    callidusBvsVersicherungssummeKunde: new FormControl<CallidusBvsVersicherungssummeKunde | null>(CallidusBvsVersicherungssummeKunde.Versicherungssumme5Mio)
  };
}
